import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  name: 'ActionsTab',
  data () {
    return {}
  },
  components: {},
  computed: {},
  methods: {}
}
